import { loadTexture } from "@/common/pixi";

export async function useSpriteLoader(input: string | string[]): Promise<void> {
  if (import.meta.env.SSR) {
    return;
  }
  await loadTexture(input);
}
